import { makeStyles } from "@material-ui/core/styles";
import { styled } from "@mui/system";

export const useStyles = makeStyles({
  datatable: {
    height: "371px",
    backgroundColor: "#eaeaea",
    color: "black",
    fontSize: "12px",
    borderRadius: "10px",
  },
  cellAction: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },
  headerCell: {
    backgroundColor: "rgba(45, 45, 45, 0.8666666667)",
    color: "white",
  },
});

export const getStatusBackgroundColor = (status) => {
  switch (status) {
    case "Open":
      return "orange";
    case "In Progress":
      return "skyblue";
    case "Resolved":
      return "rgb(0, 197, 53)";
    case "Closed":
      return "#F75D59";
    default:
      return "";
  }
};

export const CustomCell = styled("div")(({ value }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  paddingLeft: "8px",
  backgroundColor: getStatusBackgroundColor(value),
}));
